<style src="./UserMenu.scss" lang="scss"></style>

<template lang="pug">
  .usermenu
    ul.usermenu__list
      li.usermenu__item(
        v-if='$accessControl.is(USER_GROUP_GUEST) && !$accessControl.is(USER_GROUP_PERSON)'
      )
        button.usermenu__button(
          @click='openLoginModal'
          type='button'
        ) {{ $l10n("ENTRY") }}

      li.usermenu__item(
        v-if='$accessControl.is(USER_GROUP_PERSON)'
      )
        router-link.usermenu__link(
          :to='`/playlists`'
          :class='isActive("playlists")'
        )
          .usermenu__icon
            Icon(
              name='playlists'
            )
          span.usermenu__label {{ $l10n("PLAYLISTS") }}

      li.usermenu__item(
        v-if='$accessControl.is(USER_GROUP_PERSON)'
      )
        router-link.usermenu__link(
          :to='`/favorites`'
          :class='isActive("favorites")'
        )
          .usermenu__icon
            Icon(
              name='favorites'
            )
          span.usermenu__label {{ $l10n("LIKED") }}

      li.usermenu__item(
        v-if='$accessControl.is(USER_GROUP_ARTIST)'
      )
        router-link.usermenu__link(
          to='/profile'
          :class='isActive("profile")'
        )
          .usermenu__icon
            Icon(
              name='star'
            )
          span.usermenu__label {{ $l10n("MY_MUSIC") }}

      li.usermenu__item(
        v-if='$accessControl.is(USER_GROUP_PERSON)'
      )
        router-link.usermenu__link(
          :to='"/logout"'
        )
          .usermenu__icon
          span.usermenu__label {{ $l10n("LOGOUT") }}
</template>
<script>
import Icon from "@/components/Icon/Icon";
import { mapActions } from "vuex";

export default {
  components: {
    Icon
  },
  methods: {
    ...mapActions({
      openModal: "modal/open"
    }),
    isActive(name) {
      return this.$route.name === name && "is-active";
    },
    openLoginModal() {
      this.openModal({ name: "login" });
    }
  }
};
</script>
